import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "src/async/apiUtils";

export const useHeaderMenus = ({ workspaceId, userId, paymentRequired = false }) => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadHeaderMenus = useCallback(async () => {
    if (!workspaceId || !userId || paymentRequired) return;

    setLoading(true);
    setError(null);

    try {
      const { data } = await apiRequest("GET", `/portal/header-menu/:workspace_id`, {
        params: { workspace_id: workspaceId },
      });

      const processedMenus = (data?.data || []).map((menuItem) => {
        // ---- SINGLE PAGE ----
        if (!menuItem.is_group) {
          const page = menuItem.page || {};

          return {
            ...page,
            _id: menuItem._id,
            headerMenu: true,
            isGroup: false,
            type: page.page_type !== "EXTERNAL_LINK" ? "internal" : "external",
            link: page.page_type !== "EXTERNAL_LINK" ? `/workspace/${workspaceId}/menu/${menuItem.form_id ? "form" : menuItem.document_id ? "document" : "page"}/${page.slug || page._id}` : page.page_link,
            image: menuItem.image || page.image || null,
          };
        }

        // ---- GROUP ----
        return {
          _id: menuItem._id,
          name: menuItem.page_alias || "Group",
          image: menuItem.image || null,
          isGroup: true,
          headerMenu: true,
          submenu: (menuItem.pages || []).map((sub) => {
            const subPage = sub.page || {};

            return {
              ...subPage,
              _id: sub._id || subPage._id,
              name: sub.form_id ? sub?.form?.name : sub.document_id ? sub?.document?.name : subPage.name || sub.page_alias,
              slug: subPage.slug || sub.slug,
              headerMenu: true,
              groupHeaderMenuSub: true,
              image: sub.image || subPage.image || null,
              type: subPage.page_type !== "EXTERNAL_LINK" ? "internal" : "external",
              link: subPage.page_type !== "EXTERNAL_LINK" ? `/workspace/${workspaceId}/menu/${sub.form_id ? "form" : sub.document_id ? "document" : "page"}/${subPage.slug || sub.slug || subPage._id}` : subPage.page_link,
              groupId: menuItem._id,
            };
          }),
        };
      });

      setMenus(processedMenus);
    } catch (err) {
      console.error("Failed to load header menus", err);
      setError(err);
      setMenus([]);
    } finally {
      setLoading(false);
    }
  }, [workspaceId, userId, paymentRequired]);

  useEffect(() => {
    loadHeaderMenus();
  }, [loadHeaderMenus]);

  return {
    menus,
    loading,
    error,
    refetch: loadHeaderMenus,
  };
};
